export const scoresTranslations = {
  fr: {
    title: "Scores & Statistiques",
    navigation: {
      dashboard: "Tableau de bord",
      back: "Retour"
    },
    errors: {
      loginRequired: "Connexion requise",
      loginRequiredDesc: "Connectez-vous pour voir vos scores et statistiques",
      loginButton: "Se connecter",
      loadingStats: "Chargement des statistiques..."
    },
    profile: {
      title: "Profil d'apprentissage",
      levelPrefix: "Niveau",
      level: "Niveau",
      xp: "Points XP",
      streak: "Série d'étude",
      cardsMastered: "Cartes maîtrisées"
    },
    tabs: {
      overview: "Vue d'ensemble",
      quiz: "QCM",
      clinical: "Cas cliniques",
      flashcards: "Flashcards",
      achievements: "Succès"
    },
    stats: {
      avgScore: "Score moyen",
      avgAccuracy: "Précision moyenne",
      questionsAnswered: "Questions répondues",
      correctAnswers: "Réponses correctes",
      completedQuizzes: "Quiz terminés",
      completedCases: "Cas terminés",
      cardsStudied: "Cartes étudiées",
      studyTime: "Temps d'étude",
      sessions: "Sessions",
      totalTime: "Temps total",
      quizTime: "Temps QCM",
      clinicalTime: "Temps cas cliniques",
      flashcardTime: "Temps flashcards"
    },
    time: {
      minutes: " min",
      seconds: " sec"
    },
    history: {
      quizTitle: "Historique des QCM",
      clinicalTitle: "Historique des cas cliniques",
      flashcardTitle: "Historique des flashcards",
      studyTitle: "Historique des sessions d'étude",
      noQuizzes: "Aucun quiz terminé",
      noQuizzesDesc: "Commencez votre premier quiz pour voir vos résultats ici",
      noQuizSessions: "Aucune session de quiz terminée",
      noClinicalCases: "Aucun cas clinique terminé",
      noClinicalCasesDesc: "Résolvez votre premier cas clinique pour voir vos résultats ici",
      noClinicalSessions: "Aucune session de cas clinique terminée",
      noFlashcards: "Aucune session de flashcards",
      noFlashcardsDesc: "Étudiez vos premières flashcards pour voir vos résultats ici",
      noStudySessions: "Aucune session d'étude terminée",
      completed: "Terminé",
      questions: "questions",
      cards: "cartes",
      difficulty: "Difficulté",
      score: "Score",
      accuracy: "Précision",
      timeSpent: "Temps passé"
    },
    session: {
      questions: "questions",
      cardsStudied: "cartes étudiées"
    },
    achievements: {
      title: "Succès débloqués",
      noAchievements: "Aucun succès débloqué",
      noAchievementsDesc: "Continuez à étudier pour débloquer vos premiers succès !",
      unlockedOn: "Débloqué le",
      unlocked: "Débloqué",
      progress: "Progression",
      dedicated: "Étudiant dévoué",
      dedicatedDesc: "Atteignez le niveau 5",
      quizExpert: "Expert en quiz",
      quizExpertDesc: "Répondez à 50 questions de quiz",
      cardMaster: "Maître des cartes",
      cardMasterDesc: "Étudiez 100 flashcards",
      streak: "Série impressionnante",
      streakDesc: "Maintenez une série d'étude de 7 jours"
    },
    difficulty: {
      easy: "Facile",
      medium: "Moyen",
      hard: "Difficile",
      expert: "Expert"
    },
    actions: {
      startQuiz: "Commencer un quiz",
      solveClinicalCase: "Résoudre un cas",
      studyFlashcards: "Étudier les flashcards"
    },
    calculators: {
      csrs: {
        name: "CSRS (Score)",
        description: "Stratification du risque de syncope canadien"
      },
      news: {
        name: "NEWS (Score)",
        description: "Score national d'alerte précoce"
      },
      diva: {
        name: "DIVA (Score)",
        description: "Prédiction de la difficulté à perfuser un enfant"
      },
      geriatricDepression: {
        name: "Échelle de dépression gériatrique",
        description: "Dépistage de la dépression chez la personne âgée"
      },
      pesi: {
        name: "PESI (Score)",
        description: "Index de sévérité de l'embolie pulmonaire"
      },
      mascc: {
        name: "MASCC (Score)",
        description: "Risque sur neutropénie fébrile"
      }
    }
  },
  en: {
    title: "Scores & Statistics",
    navigation: {
      dashboard: "Dashboard",
      back: "Back"
    },
    errors: {
      loginRequired: "Login required",
      loginRequiredDesc: "Please log in to view your scores and statistics",
      loginButton: "Log in",
      loadingStats: "Loading statistics..."
    },
    profile: {
      title: "Learning profile",
      levelPrefix: "Level",
      level: "Level",
      xp: "XP Points",
      streak: "Study streak",
      cardsMastered: "Cards mastered"
    },
    tabs: {
      overview: "Overview",
      quiz: "MCQ",
      clinical: "Clinical cases",
      flashcards: "Flashcards",
      achievements: "Achievements"
    },
    stats: {
      avgScore: "Average score",
      avgAccuracy: "Average accuracy",
      questionsAnswered: "Questions answered",
      correctAnswers: "Correct answers",
      completedQuizzes: "Completed quizzes",
      completedCases: "Completed cases",
      cardsStudied: "Cards studied",
      studyTime: "Study time",
      sessions: "Sessions",
      totalTime: "Total time",
      quizTime: "MCQ time",
      clinicalTime: "Clinical cases time",
      flashcardTime: "Flashcards time"
    },
    time: {
      minutes: " min",
      seconds: " sec"
    },
    history: {
      quizTitle: "MCQ History",
      clinicalTitle: "Clinical Cases History",
      flashcardTitle: "Flashcards History",
      studyTitle: "Study Sessions History",
      noQuizzes: "No completed quizzes",
      noQuizzesDesc: "Start your first quiz to see your results here",
      noQuizSessions: "No completed quiz sessions",
      noClinicalCases: "No completed clinical cases",
      noClinicalCasesDesc: "Solve your first clinical case to see your results here",
      noClinicalSessions: "No completed clinical case sessions",
      noFlashcards: "No flashcard sessions",
      noFlashcardsDesc: "Study your first flashcards to see your results here",
      noStudySessions: "No completed study sessions",
      completed: "Completed",
      questions: "questions",
      cards: "cards",
      difficulty: "Difficulty",
      score: "Score",
      accuracy: "Accuracy",
      timeSpent: "Time spent"
    },
    session: {
      questions: "questions",
      cardsStudied: "cards studied"
    },
    achievements: {
      title: "Unlocked achievements",
      noAchievements: "No achievements unlocked",
      noAchievementsDesc: "Keep studying to unlock your first achievements!",
      unlockedOn: "Unlocked on",
      unlocked: "Unlocked",
      progress: "Progress",
      dedicated: "Dedicated student",
      dedicatedDesc: "Reach level 5",
      quizExpert: "Quiz expert",
      quizExpertDesc: "Answer 50 quiz questions",
      cardMaster: "Card master",
      cardMasterDesc: "Study 100 flashcards",
      streak: "Impressive streak",
      streakDesc: "Maintain a 7-day study streak"
    },
    difficulty: {
      easy: "Easy",
      medium: "Medium",
      hard: "Hard",
      expert: "Expert"
    },
    actions: {
      startQuiz: "Start quiz",
      solveClinicalCase: "Solve case",
      studyFlashcards: "Study flashcards"
    },
    calculators: {
      csrs: {
        name: "CSRS Score",
        description: "Canadian Syncope Risk Score"
      },
      news: {
        name: "NEWS Score",
        description: "National Early Warning Score"
      },
      diva: {
        name: "DIVA Score",
        description: "Prediction of difficult IV access in children"
      },
      geriatricDepression: {
        name: "Geriatric Depression Scale",
        description: "Depression screening in elderly patients"
      },
      pesi: {
        name: "PESI Score",
        description: "Pulmonary Embolism Severity Index"
      },
      mascc: {
        name: "MASCC Score",
        description: "Risk assessment for febrile neutropenia"
      }
    }
  },
  es: {
    title: "Puntuaciones y Estadísticas",
    navigation: {
      dashboard: "Panel de control",
      back: "Atrás"
    },
    errors: {
      loginRequired: "Inicio de sesión requerido",
      loginRequiredDesc: "Inicia sesión para ver tus puntuaciones y estadísticas",
      loginButton: "Iniciar sesión",
      loadingStats: "Cargando estadísticas..."
    },
    profile: {
      title: "Perfil de aprendizaje",
      levelPrefix: "Nivel",
      level: "Nivel",
      xp: "Puntos XP",
      streak: "Racha de estudio",
      cardsMastered: "Tarjetas dominadas"
    },
    tabs: {
      overview: "Resumen",
      quiz: "MCQ",
      clinical: "Casos clínicos",
      flashcards: "Tarjetas de estudio",
      achievements: "Logros"
    },
    stats: {
      avgScore: "Puntuación promedio",
      avgAccuracy: "Precisión promedio",
      questionsAnswered: "Preguntas respondidas",
      correctAnswers: "Respuestas correctas",
      completedQuizzes: "Cuestionarios completados",
      completedCases: "Casos completados",
      cardsStudied: "Tarjetas estudiadas",
      studyTime: "Tiempo de estudio",
      sessions: "Sesiones",
      totalTime: "Tiempo total",
      quizTime: "Tiempo MCQ",
      clinicalTime: "Tiempo casos clínicos",
      flashcardTime: "Tiempo tarjetas"
    },
    time: {
      minutes: " min",
      seconds: " seg"
    },
    history: {
      quizTitle: "Historial de MCQ",
      clinicalTitle: "Historial de casos clínicos",
      flashcardTitle: "Historial de tarjetas",
      studyTitle: "Historial de sesiones de estudio",
      noQuizzes: "No hay cuestionarios completados",
      noQuizzesDesc: "Comienza tu primer cuestionario para ver los resultados aquí",
      noQuizSessions: "No hay sesiones de cuestionario completadas",
      noClinicalCases: "No hay casos clínicos completados",
      noClinicalCasesDesc: "Resuelve tu primer caso clínico para ver los resultados aquí",
      noClinicalSessions: "No hay sesiones de casos clínicos completadas",
      noFlashcards: "No hay sesiones de tarjetas",
      noFlashcardsDesc: "Estudia tus primeras tarjetas para ver los resultados aquí",
      noStudySessions: "No hay sesiones de estudio completadas",
      completed: "Completado",
      questions: "preguntas",
      cards: "tarjetas",
      difficulty: "Dificultad",
      score: "Puntuación",
      accuracy: "Precisión",
      timeSpent: "Tiempo empleado"
    },
    session: {
      questions: "preguntas",
      cardsStudied: "tarjetas estudiadas"
    },
    achievements: {
      title: "Logros desbloqueados",
      noAchievements: "No hay logros desbloqueados",
      noAchievementsDesc: "¡Sigue estudiando para desbloquear tus primeros logros!",
      unlockedOn: "Desbloqueado el",
      unlocked: "Desbloqueado",
      progress: "Progreso",
      dedicated: "Estudiante dedicado",
      dedicatedDesc: "Alcanza el nivel 5",
      quizExpert: "Experto en cuestionarios",
      quizExpertDesc: "Responde 50 preguntas de cuestionario",
      cardMaster: "Maestro de tarjetas",
      cardMasterDesc: "Estudia 100 tarjetas",
      streak: "Racha impresionante",
      streakDesc: "Mantén una racha de estudio de 7 días"
    },
    difficulty: {
      easy: "Fácil",
      medium: "Medio",
      hard: "Difícil",
      expert: "Experto"
    },
    actions: {
      startQuiz: "Comenzar cuestionario",
      solveClinicalCase: "Resolver caso",
      studyFlashcards: "Estudiar tarjetas"
    },
    calculators: {
      csrs: {
        name: "Puntuación CSRS",
        description: "Puntuación canadiense de riesgo de síncope"
      },
      news: {
        name: "Puntuación NEWS",
        description: "Puntuación nacional de alerta temprana"
      },
      diva: {
        name: "Puntuación DIVA",
        description: "Predicción de acceso IV difícil en niños"
      },
      geriatricDepression: {
        name: "Escala de Depresión Geriátrica",
        description: "Detección de depresión en pacientes ancianos"
      },
      pesi: {
        name: "Puntuación PESI",
        description: "Índice de gravedad de embolia pulmonar"
      },
      mascc: {
        name: "Puntuación MASCC",
        description: "Evaluación de riesgo para neutropenia febril"
      }
    }
  }
};